export var AutomationMode;
(function (AutomationMode) {
    AutomationMode["NONE"] = "";
    AutomationMode["TIME"] = "time";
    AutomationMode["SYSTEM"] = "system";
    AutomationMode["LOCATION"] = "location";
})(AutomationMode || (AutomationMode = {}));
